const BrandDeKonstrucktorMain = {
    namespaced: true,
    state: {
        name: null,
        savedword:null,
        trademarkCategory:[],
        preloader_inner_webSearch: 0,
        preloader_inner_domainSearch: 0,
        preloader_inner_trademarkSearch: 0,
        preloader_inner_socialSearch: 0,

        dekonstrucktor_selected_types: null || [],
    },
    mutations: {
        setName: function (state, payload) {
            state.name = payload;
        },
        setdekonstrucktor_selected_types:function (state,payload) {
            state.dekonstrucktor_selected_types = payload;
        },

        setpreloader_inner_webSearch:function (state,payload) {
            state.preloader_inner_webSearch = payload;
        } ,
        setpreloader_inner_domainSearch:function (state,payload) {
            state.preloader_inner_domainSearch = payload;
        },
        setpreloader_inner_trademarkSearch:function (state,payload) {
            state.preloader_inner_trademarkSearch = payload;
        },
        setpreloader_inner_socialSearch:function (state,payload) {
            state.preloader_inner_socialSearch = payload;
        }
    },
    actions: {
        setName: function (state, payload) {
            state.commit('setName', payload['name']);
        }
    },
    getters: {
        getName: function (state) {
            return state.name;
        }
    },
}
export default BrandDeKonstrucktorMain